import { LoaderFunctionArgs } from 'react-router-dom'
import { getDashboardStats } from '../../action/dashboard'

export const dashboardLoader = async ( args: LoaderFunctionArgs ) => {

    await getDashboardStats()

}
